import { type EKycVerificationStatus, type CancelationReason } from '@exam-center/graphql';
import {
  CheckCircleOutlineRoundedIcon,
  DoNotDisturbOnOutlinedIcon,
  EllipsisText,
  type GridColDef,
} from '@shared/components';

import { CancelationReasonCell } from '../cancelation-reason-cell';
import { EKycVerificationStatusIcon } from '../ekyc-verification-status-icon';

export interface ExamineeColumn {
  id: string;
  title: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  email: string;
  examCourseCode: string;
  isExamReady: boolean;
  eKycStatus: EKycVerificationStatus;
  status: string;
  cancelationReasonCategory?: CancelationReason | null;
  remark?: string | null;
  action: JSX.Element;
}

export const computerColumns: GridColDef<ExamineeColumn>[] = [
  {
    field: 'fullName',
    headerName: 'ชื่อ-นามสกุล',
    flex: 1,
    minWidth: 240,
    sortable: false,
    renderCell: ({ row }) => {
      const { title, firstName, middleName, lastName } = row;

      return [title, firstName, middleName, lastName].filter(Boolean).join(' ');
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    minWidth: 240,
    sortable: false,
    renderCell: ({ row }) => {
      const { email } = row;

      return <EllipsisText>{email ?? '-'}</EllipsisText>;
    },
  },
  {
    field: 'examCourseCode',
    headerName: 'หลักสูตร',
    width: 120,
    sortable: false,
  },
  {
    field: 'isExamReady',
    headerName: 'ชุดข้อสอบ',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      const { isExamReady } = row;

      if (isExamReady) {
        return (
          <CheckCircleOutlineRoundedIcon
            fontSize='small'
            sx={{
              color: (theme) => theme.palette.success.main,
            }}
          />
        );
      } else {
        return (
          <DoNotDisturbOnOutlinedIcon
            fontSize='small'
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          />
        );
      }
    },
  },
  {
    field: 'eKycStatus',
    headerName: 'e-KYC',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      const { eKycStatus } = row;

      return <EKycVerificationStatusIcon eKycStatus={eKycStatus} />;
    },
  },
  {
    field: 'status',
    headerName: 'สถานะผู้เข้าสอบ',
    width: 160,
    sortable: false,
  },
  {
    field: 'remark',
    headerName: 'Remark',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      const { cancelationReasonCategory, remark } = row;

      return (
        <CancelationReasonCell
          cancelationReasonCategory={cancelationReasonCategory}
          remark={remark}
        />
      );
    },
  },
  {
    field: 'action',
    headerName: '',
    width: 48,
    sortable: false,
    renderCell: ({ row }) => {
      return row.action;
    },
  },
];

export const paperBasedColumns: GridColDef<ExamineeColumn>[] = [
  {
    field: 'fullName',
    headerName: 'ชื่อ-นามสกุล',
    flex: 1,
    minWidth: 240,
    sortable: false,
    renderCell: ({ row }) => {
      const { title, firstName, middleName, lastName } = row;

      return [title, firstName, middleName, lastName].filter(Boolean).join(' ');
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    minWidth: 240,
    sortable: false,
    renderCell: ({ row }) => {
      const { email } = row;

      return <EllipsisText>{email ?? '-'}</EllipsisText>;
    },
  },
  {
    field: 'examCourseCode',
    headerName: 'หลักสูตร',
    width: 120,
    sortable: false,
  },
  {
    field: 'eKycStatus',
    headerName: 'e-KYC',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      const { eKycStatus } = row;

      return <EKycVerificationStatusIcon eKycStatus={eKycStatus} />;
    },
  },
  {
    field: 'status',
    headerName: 'สถานะผู้เข้าสอบ',
    width: 160,
    sortable: false,
  },
  {
    field: 'remark',
    headerName: 'Remark',
    width: 200,
    sortable: false,
    renderCell: ({ row }) => {
      const { cancelationReasonCategory: cancellationReasonCategory, remark } = row;

      return (
        <CancelationReasonCell
          cancelationReasonCategory={cancellationReasonCategory}
          remark={remark}
        />
      );
    },
  },
  {
    field: 'action',
    headerName: '',
    width: 48,
    sortable: false,
    renderCell: ({ row }) => {
      return row.action;
    },
  },
];
